import { ReactNode } from 'react';
import { Stack } from '@/ui/common/Stack';
import { ErrorMessages } from './ErrorMessages';
import styles from './styles.module.scss';

type LabelType = 'required';

type Props = {
  /** フィールドのラベルのhtmlFor属性 */
  htmlFor: string;
  /** フィールドのラベルの種類 */
  labelType?: LabelType;
  /** フィールドのラベル */
  labelText: string;
  /** ラベルと入力フィールドの間に表示するメッセージ */
  beforeMessage?: ReactNode;
  /** フィールドの子要素 */
  children: ReactNode;
  /** エラーメッセージの配列 */
  errorMessages?: string[];
  /** フィールドの非活性状態フラグ */
  disabled?: boolean;
};

export const FieldWrapper: React.FC<Props> = ({
  htmlFor,
  labelType,
  labelText,
  beforeMessage,
  children,
  errorMessages,
  disabled,
}) => (
  <Stack gap={4}>
    <label htmlFor={htmlFor} className={`${styles.label} ${disabled ? styles.disabledLabel : ''}`}>
      {labelText}
      {labelType === 'required' && <span className={styles.requiredLabel}>必須</span>}
    </label>
    {beforeMessage && <span className={styles.beforeMessage}>{beforeMessage}</span>}
    <div className={styles.childrenContainer}>{children}</div>
    {errorMessages && <ErrorMessages messages={errorMessages} />}
  </Stack>
);
